export const FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST = 'FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST';
export const FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS = 'FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS';
export const FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE = 'FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE';

export const FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_REQUEST = 'FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_REQUEST';
export const FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_SUCCESS = 'FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_SUCCESS';
export const FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_FAILURE = 'FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_FAILURE';

export const CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST = 'CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST';
export const CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS = 'CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS';
export const CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE = 'CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE';

export const UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST = 'UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST';
export const UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS = 'UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS';
export const UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE = 'UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE';

export const DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST = 'DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST';
export const DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS = 'DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS';
export const DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE = 'DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE';

export const FETCH_SINGLE_CUSTOMER_PO_DETAIL_REQUEST = 'FETCH_SINGLE_CUSTOMER_PO_DETAIL_REQUEST';
export const FETCH_SINGLE_CUSTOMER_PO_DETAIL_SUCCESS = 'FETCH_SINGLE_CUSTOMER_PO_DETAIL_SUCCESS';
export const FETCH_SINGLE_CUSTOMER_PO_DETAIL_FAILURE = 'FETCH_SINGLE_CUSTOMER_PO_DETAIL_FAILURE';

export const FETCH_ARTICLE_NO_DATA_REQUEST = 'FETCH_ARTICLE_NO_DATA_REQUEST';
export const FETCH_ARTICLE_NO_DATA_SUCCESS = 'FETCH_ARTICLE_NO_DATA_SUCCESS';
export const FETCH_ARTICLE_NO_DATA_FAILURE = 'FETCH_ARTICLE_NO_DATA_FAILURE';

export const CUSTOMER_PO_DETAILS_FORM_RESET = 'CUSTOMER_PO_DETAILS_FORM_RESET';

export const CREATE_USER_FORM_CUSTOMER_PO_DETAIL = 'CREATE_USER_FORM_CUSTOMER_PO_DETAIL';